import { z } from 'zod';

export function isRequiredInProd<T extends z.ZodType>(type: T) {
  return (type as unknown as z.ZodType).refine(
    (v) => process.env['NODE_ENV'] !== 'production' || v != null,
  ) as unknown as T;
}

export const SWAGGER_SCHEMA = z.object({
  ENABLE: z
    .enum(['true', 'false'])
    .transform((val) => val === 'true')
    .default(false),
  OUTPUT_PATH: z.string().optional(),
  API_NAME: z.string(),
  API_DESCRIPTION: z.string(),
  CONTACT_NAME: z.string(),
  CONTACT_EMAIL: z.email(),
});

export type SWAGGER = z.infer<typeof SWAGGER_SCHEMA>;

export const MS_SQL_DB_SCHEMA = z.object({
  USERNAME: z.string(),
  PASSWORD: z.string(),
  HOST: z.string(),
  PORT: z.coerce.number().min(0).max(65535).default(1433),
  NAME: z.string(),
  SSL_DISABLED: z
    .enum(['true', 'false'])
    .transform((val) => val === 'true')
    .default(false),
});

export type MS_SQL_DB = z.infer<typeof MS_SQL_DB_SCHEMA>;

export const PUBSUB_SCHEMA = z.object({
  AZURE_SERVICE_BUS_CONNECTION_STRING: z.string().optional(),
  LOCAL_PUBSUB_PORT: z.coerce.number().min(0).max(65535).optional(),
  REDIS_STREAMS_HOST: z.string().optional(),
  REDIS_STREAMS_PORT: z.coerce.number().optional().default(6379),
  REDIS_STREAMS_PASSWORD: z.string().optional(),
  REDIS_STREAMS_DB: z.coerce.number().int().min(0).optional().default(3),
  REDIS_STREAMS_PREFIX: z.string().optional().default('pubsub'),
  REDIS_STREAMS_MAXLEN: z.coerce.number().int().positive().optional().default(100000),
  REDIS_STREAMS_DLQ_MAXLEN: z.coerce.number().int().positive().optional().default(20000),
  REDIS_STREAMS_RETRY_BASE_DELAY_MS: z.coerce.number().int().positive().optional().default(1000),
  REDIS_STREAMS_RETRY_MAX_DELAY_MS: z.coerce.number().int().positive().optional().default(60000),
  OWN_TOPIC_NAME: z.string(),
});

export const STORAGE_SCHEMA = z.object({
  AZURE_STORAGE_ACCOUNT_CONNECTION_STRING: isRequiredInProd(z.string().optional()),
  AZURE_STORAGE_ACCOUNT_REPLACE_BASE_URL: z.url().optional(),
});

export const REDIS_SCHEMA = z.object({
  HOST: z.string(),
  PORT: z.coerce.number().optional().default(6379),
  PASSWORD: z.string().optional(),
});

export type REDIS = z.infer<typeof REDIS_SCHEMA>;
